import { TableActionButton } from "./Components";


export default function TableAction({children, onClick, disabled}){
    return (
        <TableActionButton onClick={onClick} $disabled={disabled}>
            {children}
        </TableActionButton>
    )
}